import { useState, useEffect } from "react";
import { API_URL } from "../../config";
import { authFetch } from "../../utils";

const LEVEL_COLOR = { 1: '#16a34a', 2: '#d97706', 3: '#dc2626' };

export default function Link112({ fileUrl, linkName, showLevel }) {
  const [level, setLevel] = useState(null);

  useEffect(() => {
    if (!showLevel) return;

    const fetchLevel = () => {
      authFetch(`${API_URL}link112/previfoc-levels?zones=3`)
        .then(res => res.ok ? res.json() : null)
        .then(data => {
          const todayLevel = data?.zones?.[0]?.today?.level;
          if (todayLevel != null) setLevel(todayLevel);
        })
        .catch(() => {});
    };

    fetchLevel();
    const interval = setInterval(fetchLevel, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, [showLevel]);

  const handleDownload = async () => {
    try {
      const resp = await authFetch(`${API_URL}link112/${fileUrl}`);

      if (!resp.ok) {
        throw new Error(`Error al obtener el enlace (${resp.status})`);
      }

      const { url } = await resp.json();
      window.open(url, "_blank", "noopener,noreferrer");
    } catch (err) {
      console.error("[Link112] Error:", err);
      alert("Error al abrir el documento.");
    }
  };

  return (
    <div onClick={handleDownload} className="link-112">
      {linkName}
      {showLevel && level != null && (
        <span style={{ marginLeft: 6, fontWeight: 700, color: LEVEL_COLOR[level] ?? '#999' }}>
          Nivel {level}
        </span>
      )}
    </div>
  );
}
